// document.addEventListener("DOMContentLoaded", function () {
//   const closeIcon = document.querySelector(".remove-video-icon");
//   const videoSection = document.querySelector(".collection-video-sec");
//   const video = document.querySelector(".collection-video video");

//   const videoClosedKey = "videoClosed_" + window.location.pathname;
//   let videoClosed = false; // <-- Flag to track if user closed the video

//   if (!videoSection || !video || !closeIcon) return;

//   if (localStorage.getItem(videoClosedKey) === "true") {
//     return;
//   } else {
//     videoSection.classList.add("visible");
//   }

//   function expandVideo(event) {
//     event.stopPropagation();
//     videoSection.classList.add("expanded");

//     setTimeout(() => {
//       if (videoClosed) return; // Don't continue if video was closed

//       video.setAttribute("muted", "");
//       video.muted = true;

//       const playPromise = video.play();
//       if (playPromise !== undefined) {
//         playPromise
//           .then(() => {
//             setTimeout(() => {
//               if (videoClosed) return; // Again check if video was closed
//               video.removeAttribute("muted");
//               video.muted = false;
//             }, 500);
//           })
//           .catch(error => {
//             console.log("Autoplay prevented, user interaction required", error);
//           });
//       }
//     }, 100);
//   }

//   videoSection.addEventListener("click", expandVideo);
//   videoSection.addEventListener("touchstart", expandVideo);

//   closeIcon.addEventListener("click", function (event) {
//     event.stopPropagation();
//     videoClosed = true; // Set flag
//     video.setAttribute("muted", "");
//     video.muted = true;
//     video.pause();
//     video.currentTime = 0;
//     video.load();
//     videoSection.style.display = "none";
//     localStorage.setItem(videoClosedKey, "true");

//     // Optional cleanup
//     videoSection.removeEventListener("click", expandVideo);
//     videoSection.removeEventListener("touchstart", expandVideo);
//   });
// });

document.addEventListener("DOMContentLoaded", function () {
  const closeIcon = document.querySelector(".remove-video-icon");
  const videoSection = document.querySelector(".collection-video-sec");
  const video = document.querySelector(".collection-video video");

  const videoClosedKey = "videoClosed_" + window.location.pathname;
  let videoClosed = false;

  if (!videoSection || !video || !closeIcon) return;

  if (localStorage.getItem(videoClosedKey) === "true") {
    return;
  } else {
    videoSection.classList.add("visible");
  }

  function expandVideo(event) {
    // Prevent expansion if the close icon was touched/clicked
    if (event.target.closest(".remove-video-icon")) return;

    event.stopPropagation();
    videoSection.classList.add("expanded");

    setTimeout(() => {
      if (videoClosed) return;

      video.setAttribute("muted", "");
      video.muted = true;

      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            setTimeout(() => {
              if (videoClosed) return;
              video.removeAttribute("muted");
              video.muted = false;
            }, 500);
          })
          .catch(error => {
            console.log("Autoplay prevented, user interaction required", error);
          });
      }
    }, 100);
  }

  videoSection.addEventListener("click", expandVideo);
  videoSection.addEventListener("touchstart", expandVideo);

  // Handle both click and touchstart for better mobile support
  ["click", "touchstart"].forEach(eventName => {
    closeIcon.addEventListener(eventName, function (event) {
      event.stopPropagation();
      videoClosed = true;

      video.setAttribute("muted", "");
      video.muted = true;
      video.pause();
      video.currentTime = 0;
      video.load();
      videoSection.style.display = "none";
      localStorage.setItem(videoClosedKey, "true");

      videoSection.removeEventListener("click", expandVideo);
      videoSection.removeEventListener("touchstart", expandVideo);
    });
  });
});